import Component from "../../lib/component";
import {ProductIntroFoot, ProductIntroFootConfig} from "./product_intro_foot";

export const ProductIntroConfig = {
    componentTypeKey: 'ProductIntro',
    baseHtmlClass: 'product_intro',
    selector: '.product_intro',

    datasetConfigKey: 'product_intro__config',
};

export class ProductIntro extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: ProductIntroConfig
        });

        this.setDatasetConfig(ProductIntroConfig.datasetConfigKey);

        const footElement = this.element.querySelector(ProductIntroFootConfig.selector);
        if (footElement) {
            this.foot = new ProductIntroFoot(footElement, this);
        }

        this.render();
    }

    render() {
        if (this.foot) {
            this.foot.render();
            this.conditionallySetHtmlClassState(!this.foot.hasOptions(), 'no_options');
        }
    }

}

